import { Api } from "./api"

export class SampleReportApi extends Api {
  constructor() {
    super('sample_reports', ['to', 'message'])
  }
}
